// extracted by mini-css-extract-plugin
module.exports = {"heading":"YesNo_heading__163jB","inputs":"YesNo_inputs__q_0YQ"};